import React from 'react'
import CreatableSelect from 'react-select/creatable'

import {
  FORM_SELECT_STYLES,
  NoIndicatorSeparator,
} from './styles'

export default function CreatableSelectCustom({
  components,
  styles,
  ...props
}) {
  return (
    <CreatableSelect
      menuPortalTarget={document.body}
      components={{
        ...components,
        IndicatorSeparator: NoIndicatorSeparator,
      }}
      styles={{
        ...FORM_SELECT_STYLES,
        ...styles,
      }}
      {...props}
    />
  )
}
